import { inject, Injectable } from '@angular/core';
import { CommunityItem, PostTypes, UserLogo } from '../../interfaces';
import { AppPlatformService } from '../app-platform.service';

@Injectable({ providedIn: 'root' })
export class ExternalPostNavigationService {
  private appPlatformService = inject(AppPlatformService);

  getExternalPostUrl(item: CommunityItem): string | null {
    const socialUrl = this.appPlatformService.getSocialMediaUrl(item);
    if (socialUrl) return socialUrl;

    const homepage = item.user?.user_homepage;
    if (homepage) {
      return `${homepage.replace(/\/$/, '')}/post/?postId=${item.post_uuid}`;
    }

    return null;
  }

  getUserHomepageUrl(item: CommunityItem): string | null {
    if (item.post_type?.slug === PostTypes.repost) {
      return item.content.community_repost?.source?.source_user?.homepage || null;
    }
    return item.user?.user_homepage || null;
  }

  getPostShareUrl(item: CommunityItem, fallbackUrl: string): string {
    return this.getExternalPostUrl(item) || fallbackUrl;
  }

  getUserLogoUrl(logo: UserLogo | string | null | undefined): string | null {
    if (!logo) return null;
    if (typeof logo === 'string') return logo || null;
    return logo.url || null;
  }
}
